<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать доставку</strong>
                </CCardHeader>
                <CCardBody>
                    <OtherDeliveryUpsertForm @success="$router.push(`/other-delivery`)" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import OtherDeliveryUpsertForm from '@/components/other-delivery/OtherDeliveryUpsertForm';

    export default {
        name: 'AdsPlaceCreate',

        components: {
            OtherDeliveryUpsertForm,
        },
    };
</script>
